var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.0002C3 20.1048 3.89543 21.0002 5 21.0002H8C9.10457 21.0002 10 20.1048 10 19.0002V16.0002C10 14.8957 9.10457 14.0002 8 14.0002H5C3.89543 14.0002 3 14.8957 3 16.0002V19.0002Z",
    stroke: "#000536",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.00023C3 9.1048 3.89543 10.0002 5 10.0002H8C9.10457 10.0002 10 9.1048 10 8.00023V5.00023C10 3.89566 9.10457 3.00023 8 3.00023H5C3.89543 3.00023 3 3.89566 3 5.00023V8.00023Z",
    stroke: "#000536",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9645 5.08601C13.1834 5.86706 13.1834 7.13339 13.9645 7.91444L16.0858 10.0358C16.8668 10.8168 18.1332 10.8168 18.9142 10.0358L21.0355 7.91444C21.8166 7.13339 21.8166 5.86706 21.0355 5.08601L18.9142 2.96469C18.1332 2.18364 16.8668 2.18364 16.0858 2.96469L13.9645 5.08601Z",
    stroke: "#000536",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.0002C14 20.1048 14.8954 21.0002 16 21.0002H19C20.1046 21.0002 21 20.1048 21 19.0002V16.0002C21 14.8957 20.1046 14.0002 19 14.0002H16C14.8954 14.0002 14 14.8957 14 16.0002V19.0002Z",
    stroke: "#000536",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgets);
export default __webpack_public_path__ + "static/media/widgets.d221548732d3aa559ae965abd4a85c77.svg";
export { ForwardRef as ReactComponent };